import { all, fork } from "redux-saga/effects";
import { appSagas } from "./system/saga";

import { inventorySagas } from "./inventory/saga";
import { saleSagas } from "./sale/saga";
import { itemOptionsSagas } from "./itemOptions/saga";
export default function* rootSaga() {
  yield all([
    fork(appSagas),

    fork(inventorySagas),
    fork(saleSagas),
    fork(itemOptionsSagas),
  ]);
}
